/**
 * Known feature flag names — single source of truth for the UI.
 *
 * Values must match the `feature_name` column in the `tenant_features` DB table
 * and the Python `FeatureName` enum in `shared/stores/feature_store.py`.
 */
export enum FeatureName {
  SHOW_LOGS = 'show_logs',
}
